import { Children, type CSSProperties, type ReactNode } from "react";
import { cn } from "@/lib/utils";

interface OrbitingCirclesProps {
	children: ReactNode;
	className?: string;
	radius?: number;
	duration?: number;
	reverse?: boolean;
	iconSize?: number;
	path?: boolean;
	pathClassName?: string;
}

export function OrbitingCircles({
	children,
	className,
	radius = 80,
	duration = 20,
	reverse = false,
	iconSize = 32,
	path = false,
	pathClassName,
}: OrbitingCirclesProps) {
	const items = Children.toArray(children);
	const spinRate = (reverse ? -360 : 360) / Math.max(duration, 0.0001);
	return (
		<>
			{path && (
				<svg
					xmlns="http://www.w3.org/2000/svg"
					aria-hidden="true"
					className="pointer-events-none absolute inset-0 size-full overflow-visible"
				>
					<circle
						cx="50%"
						cy="50%"
						r={radius}
						fill="none"
						strokeWidth={1.5}
						strokeDasharray="5 6"
						className={cn(
							"stroke-muted-foreground/35 dark:stroke-muted-foreground/40",
							pathClassName,
						)}
					/>
				</svg>
			)}
			{items.map((child, index) => {
				const angle = (360 / items.length) * index;
				return (
					<div
						key={`orbit-${angle}`}
						style={
							{
								"--angle": angle,
								"--radius": radius,
								"--spin-rate": spinRate,
								width: iconSize,
								height: iconSize,
							} as CSSProperties
						}
						className={cn(
							"orbit-item pointer-events-none absolute top-1/2 left-1/2 flex items-center justify-center",
							className,
						)}
					>
						{child}
					</div>
				);
			})}
		</>
	);
}
